import React from 'react';
import { motion } from 'framer-motion';
export function Hero({
  onNavigate
}: {
  onNavigate?: (page: string) => void;
}) {
  return <section className="relative w-full min-h-screen flex items-center pt-20 pb-16 overflow-hidden bg-white" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full h-full flex flex-col lg:flex-row items-center relative z-10" data-id="element-69">
        {/* Left Content Card - Overlapping */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="w-full lg:w-1/2 z-20 lg:-mr-24 mt-8 lg:mt-0 order-2 lg:order-1" data-id="element-70">
          <div className="bg-white/95 backdrop-blur-sm p-8 md:p-12 lg:p-16 shadow-xl border-l-4 border-primary relative" data-id="element-71">
            {/* Blue accent line above headline */}
            <div className="w-16 h-1 bg-primary mb-8" data-id="element-72"></div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight tracking-tight mb-6 uppercase" data-id="element-73">
              The Search firm that's never failed
            </h1>

            <h2 className="text-xl md:text-2xl text-primary font-bold mb-6 uppercase tracking-wide" data-id="element-74">
              Boutique Retained Executive Search for High-Tech Companies.
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-xl" data-id="element-75">
              Whiterock Partners is a boutique retained executive search firm
              that helps high-tech companies recruit key executives. Our clients
              include Seed Stage, Series A, Expansion Stage, and Later Stage
              companies.
            </p>

            <div className="flex flex-wrap gap-4" data-id="element-76">
              <a href="#" onClick={e => {
              e.preventDefault();
              onNavigate?.('contact');
            }} className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium text-white bg-primary hover:bg-primary-dark transition-colors duration-200 shadow-md" data-id="element-77">
                GET IN TOUCH
              </a>
              <a href="#" onClick={e => {
              e.preventDefault();
              onNavigate?.('services');
            }} className="inline-flex items-center justify-center px-8 py-3 border border-gray-300 text-base font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200" data-id="element-78">
                OUR SERVICES
              </a>
            </div>
          </div>
        </motion.div>

        {/* Right Image - Background */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="w-full lg:w-3/4 h-[35vh] lg:h-[55vh] relative order-1 lg:order-2" data-id="element-79">
          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent z-10" data-id="element-80"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qzxpMm3KHxB2jMHJgbhrhE/Austin.jpg" alt="Austin Texas skyline" className="w-full h-full object-cover shadow-2xl" data-id="element-81" />
        </motion.div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 -z-10 hidden lg:block" data-id="element-82"></div>
    </section>;
}